import config from "react-global-configuration"
import { put, takeLatest, select } from "redux-saga/effects"

import { SET_CALL } from "client/services/constants"
import { getCall } from "containers/Call/services/actions"
import stripeActions from "containers/Stripe/services/actions"

import { request } from "lib/request"
import { ERROR_API } from "types/error"
import { Call, CallRequest, ResponseCall } from "types/payload"
import { Action, GFlow, GWatcher, Message } from "types/redux"

import actions from "./actions"
import { TLC_REQUEST, GET_CALL_PRICE, PRICE_SUCCESS } from "./constants"
import { languages } from "locales/languages"
import { getCurrentSelectedPatientId } from "containers/Survey/services/selector"
import { PATH } from "containers/Survey/models"

async function createConsultationApi(
  payload: CallRequest
): Promise<ResponseCall> {
  const orderUrl = config.get("call.post")
  return await request(orderUrl, {
    method: "POST",
    payload,
  })
}
// Pharmacist prevention checkup ("bilan prévention"): recorded as a Consultation, not a TLC
function* createPreventionConsultationApi(payload: any): any {
  const consultationUrl = config.get("consultation.post.prevention")
  const { medical, relative_id, documents, vitals } = payload
  return yield request(consultationUrl, {
    method: "POST",
    payload: { medical, relative_id, documents, vitals },
  })
}

function* tlcFlow({
  payload,
}: Action<CallRequest>): GFlow<ResponseCall | Message> {
  let response = {requires_action: null, payment_intent_client_secret: null, status: null, call: null};
  yield put(stripeActions.hasStripeError(false))
  const isPharmacist = !!(payload as any)?.medical?.prevention
  try {
    if(isPharmacist) {
      const preventionResponse = yield createPreventionConsultationApi(payload)
      if (preventionResponse?.status === "ok" && preventionResponse.consultation) {
        yield put(
          actions.success({ ...preventionResponse.consultation, isConsultation: true } as Call)
        )
      } else {
        yield put(actions.error(languages.cannotLoadTLC))
      }
      return
    }
    response = yield createConsultationApi(payload)
    const { requires_action, payment_intent_client_secret } = response
    if (requires_action && payment_intent_client_secret)
      yield put(actions.paymentRequiresAction(payment_intent_client_secret))
    else if (response.status === "ok" && response.call) {
      yield put({ type: SET_CALL, payload: response.call })
      yield put(getCall())
      yield put(actions.success(response.call as Call))
    } else {
      yield put(actions.error(languages.cannotLoadTLC))
    }
  } catch (error: any) {
    console.error(error, {
      route: config.get("call.post")
    })
    if (error?.code && error.code === ERROR_API.STRIPE)
      yield put(stripeActions.hasStripeError(true))

    if (error?.message) yield put(actions.error(error.message))
    else
      yield put(
        actions.error((error as string) ?? languages.cannotLoadTLC)
      )
  }
}

function* getCallPrice() {
  const treating_doctor_status = yield select(({survey}) => survey.answers.find((a) => a.questionId === PATH.doctor_available)?.value?.[0]);
  const relativeId = yield select(getCurrentSelectedPatientId);
  let queryParams = relativeId !== 0 ? `?relative_id=${relativeId}` : '';
  if(treating_doctor_status) {
    if(queryParams.length > 0) {
      queryParams = `${queryParams}&treating_doctor_status=${treating_doctor_status}`
    } else {
      queryParams = `?treating_doctor_status=${treating_doctor_status}`
    }
  }
  try {
    const response = yield request(`/calls/price${queryParams}`, {
      method: 'GET'
    })
    yield put({type: PRICE_SUCCESS, payload: response})
  } catch(error) {

  }
}

function* paymentWatcher(): GWatcher {
  yield takeLatest(TLC_REQUEST, tlcFlow)
  yield takeLatest(GET_CALL_PRICE, getCallPrice)
}

export default paymentWatcher
